<template>
  <hsc-window-style-metal>
    <hsc-window
      :is-open="isVisibleConfWindow"
      :title="`Configuration Window - ${reportTitle}`"
      :resizable="true"
      :min-width="400"
      :min-height="400"
      :width="windowWidth"
      :height="windowHeight"
      @resize="windowResize"
    >
      <b-container
        class="main-container mx-4"
        fluid
      >
        <b-row class="h-100 w-100">
          <div
            v-if="typeof (getCurrentGraphConfWindow) === 'undefined' || getCurrentGraphConfWindow === ''"
            id="loading-animation"
          >
            <b-spinner
              variant="primary"
              label="Loading"
            />
          </div>
          <CronoStepFit
            v-else-if="getCurrentGraphConfWindow === 'CHRONO_VALUES'"
            ref="configComponent"
            :sectionconfig="sectionConfig"
          />
          <AreasOfInterest
            v-else-if="getCurrentGraphConfWindow === 'AREA_INTEREST_VALUES'"
            ref="configComponent"
            :sectionconfig="sectionConfig"
          />
          <b-container
            v-else-if="getCurrentGraphConfWindow === 'ERROR'"
            class="h-100"
          >
            <b-row
              align-v="center"
              class="h-100"
            >
              <b-col>
                <h1>Sorry, no results were found for your request.</h1>
                <h2>The configuration could not load properly</h2>
                <p>{{ getErrorMssgConfWindow }}</p>
              </b-col>
              <b-col md="auto">
                <img
                  id="elemNotFoundImg"
                  src="@/assets/configurationWindow/Error.png"
                  alt="Element not found"
                  :height="getHeigthConfWindow * 0.85"
                >
              </b-col>
            </b-row>
          </b-container>
        </b-row>
      </b-container>
      <div class="btns-commands buttons-page">
        <b-button
          variant="danger"
          class="mr-3"
          @click="calcelAction"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="typeof (getCurrentGraphConfWindow) === 'undefined' || getCurrentGraphConfWindow === '' || getCurrentGraphConfWindow === 'ERROR'"
          @click="nextAction"
        >
          <span v-if="page >= (getGraphsConfWindow.length - 1)">Done</span>
          <span v-else>Next</span>
        </b-button>
      </div>

      <b-button
        v-if="getGraphsConfWindow.length > 1 && page > 0"
        class="btn-prev buttons-page"
        variant="primary"
        @click="previousAction"
      >
        Previous
      </b-button>
    </hsc-window>
  </hsc-window-style-metal>
</template>

<script>
//https://github.com/michitaro/vue-window
import { mapGetters, mapActions } from 'vuex'
import CronoStepFit from './CronoStepFit'
import AreasOfInterest from './AreasOfInterest'
import ConfWindowPrep from '@/functions/confWindowPrep.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'

export default {
	name: 'ConfigurationWindow',
	components: {
		CronoStepFit,
		AreasOfInterest
	},
	data() {
		return {
			reportTitle: '',
			page: -1,
			ConfigName,
			windowWidth: 900,
			sectionConfig: ''
		}
	},
	computed: mapGetters(['isVisibleConfWindow', 'getGraphsConfWindow', 'getCurrentGraphConfWindow', 'getErrorMssgConfWindow', 'getHeigthConfWindow', 'getCurrentReportViewer', 'isToolSideBarVisibleReportViewer', 'getWidthWindowMainApp', 'getHeightWindowMainApp']),
	watch: {
		isVisibleConfWindow(newValue, oldValue) {
			this.setCurrentGraphConfWindow('')//Clean the memory of any configuration component, then it gives a fresh setup for the next
			if (newValue && newValue != oldValue) { //When the visibility is set on, it resets the page number
				this.page = 0
			}
			if (!newValue) {
				this.page = -1
			}
		},
		page(newValue) {
			this.setCurrentGraphConfWindow('') //Clean the memory of any configuration component, then it gives a fresh setup for the next
			if (newValue < 0)
				return;
			this.sectionConfig = this.getGraphsConfWindow[newValue].study
			this.reportTitle = this.getCurrentReportViewer.name
			this.setErrorMssgConfWindow('')
			try {

				ConfWindowPrep[this.getGraphsConfWindow[newValue].type](this, this.getGraphsConfWindow[newValue].study).then(response => {
					if (response.success) {
						response.parent.setCurrentGraphConfWindow(response.parent.getGraphsConfWindow[response.parent.page].type)
					}
					else {
						response.parent.showErrorConfWindow(response.lastError)
					}
				})
			}
			catch (error) {
				this.showErrorConfWindow('Configuration module not valid')
			}
		},
		getWidthWindowMainApp(newValue) {
			const widthTools = this.convertRemToPixels(25)
			this.windowWidth = (newValue - widthTools) * 0.95
		},
		getHeightWindowMainApp(newValue) {
			this.windowHeight = newValue * 0.75
		}
	},
	created() {
		const widthTools = this.convertRemToPixels(25)
		const widthWindow = this.getWidthWindowMainApp
		const heightWindow = this.getHeightWindowMainApp
		this.windowWidth = (widthWindow - widthTools) * 0.95
		this.windowHeight = heightWindow * 0.75
	},
	methods: {
		...mapActions(['setVisibleConfWindow', 'setSizeWindow', 'setCurrentGraphConfWindow', 'setErrorMssgConfWindow', 'setConfigurationCongWindow', 'setPlotCPConf', 'setPlotAoFConf', 'showErrorConfWindow', 'setForceUpdateReportViewer', 'addMessageTerminalSection', 'setConfigReportModifiedReportViewer']),
		convertRemToPixels(rem) {
			return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
		},
		windowResize(e) {
			this.setSizeWindow({ newWidth: e.width, newHeight: e.height })
		},
		nextAction() {
			if ('configComponent' in this.$refs && typeof (this.$refs.configComponent) !== 'undefined') {
				if (!this.$refs.configComponent.isReady()) {
					const warnTitle = 'Not valid data'
					const warnText = 'Please verify the inputs, one or more are not valid.'
					const warnZone = 'Condiguration Window'
					this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING, warnTitle, warnText, warnZone)
					return
				}
				this.$refs.configComponent.done()
			}
			const currReport = this.getCurrentReportViewer
			currReport.dateLastUpdate = new Date().toLocaleString()
			this.setConfigReportModifiedReportViewer()
			if (!('configWindows' in this.getCurrentReportViewer)) {
				this.$set(this.getCurrentReportViewer, 'configWindows', [])
			}
			if (!this.getCurrentReportViewer.configWindows.includes(this.getCurrentGraphConfWindow)) {
				this.getCurrentReportViewer.configWindows.push(this.getCurrentGraphConfWindow)
			}
			if (this.page >= (this.getGraphsConfWindow.length - 1)) {
				this.setVisibleConfWindow(false)
				this.getCurrentReportViewer.isReady = true //The report was configured at least once
				if (!this.isToolSideBarVisibleReportViewer) {
					this.setForceUpdateReportViewer(1)
				}
			}
			else {
				this.page++
			}
		},
		previousAction() {
			this.page--
		},
		calcelAction() {
			this.setVisibleConfWindow(false)
		}
	}
}
</script>

<style lang="scss" scoped>
.buttons-page {
	position: absolute;
	bottom: 0;
}

.btns-commands {
	right: 0;
}

.main-container {
	height: 87%;
}

::v-deep .tab-content {
	height: 100%;
	overflow-y: auto;
}

::v-deep .content {
	background-color: white;
}

::v-deep .titlebar {
	background: white !important;
	background-color: var(--primary) !important;
}

::v-deep .title {
	font-weight: bold;
	color: white;
	font-size: 1.25rem;
}

#loading-animation {
	margin: 0;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

#elemNotFoundImg {
	border-radius: 20px;
	margin: 2rem;
}
</style>
